/*
 *  -----------------------------------------------------------------------
 *    <copyright file="reports-exists-modal.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { useTranslation } from 'hooks';
import { CustomDialog, DialogTitle, DialogContent } from 'views/components/core/dialog';

const ReportExistsModal = ({ open, onClose }: any) => {
    const { t } = useTranslation();

    return (
        <CustomDialog
            onClose={onClose}
            aria-labelledby="add-risk"
            fullWidth
            scroll="paper"
            maxWidth="md"
            open={open}
            className="inactivate-cv-dialog"
        >
            <DialogTitle id="report-exists-title">
                {t('ra:unableToCreateReport')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={onClose}
                    data-testid="close-dialog"
                />
            </DialogTitle>

            <DialogContent className="add-risk-dialog-content remove-inactive-cv">
                <span className="confirm-text">{t('ra:unableToCreateReportMessage')}</span>
                <span className="confirm-text pb">{t('ra:unableToCreateReportMessage2')}</span>
            </DialogContent>
        </CustomDialog>
    );
};

export default ReportExistsModal;
